module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Copyright Page",
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "CRT4"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page v. ",
      "epub:type": "pagebreak",
      "id": "pg_v",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("© 2023, Text by Debra Magpie Earling")])]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("All rights reserved. Except for brief quotations in critical articles or reviews, no part of this book may be reproduced in any manner without prior written permission from the publisher: Milkweed Editions, 1011 Washington Avenue South, Suite 300, Minneapolis, Minnesota 55415.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("(800) 520-6455")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_c('a', {
    attrs: {
      "href": "http://milkweed.org",
      "target": "_blank"
    }
  }, [_vm._v("milkweed.org")])]), _vm._v(" "), _c('p', {
    staticClass: "CRT1"
  }, [_vm._v("Published 2023 by Milkweed Editions")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Printed in Canada")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Cover design by Mary Austin Speaker")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("Cover art by John James Audubon")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_vm._v("23 24 25 26 27 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "CRT"
  }, [_c('i', [_vm._v("First Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "CRT0"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("Names: Earling, Debra Magpie, author.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("Title: The lost journals of Sacajewea / Debra Magpie Earling.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("Description: First edition. | Minneapolis, Minnesota : Milkweed Editions, 2022. | Summary: “From the award-winning author of Perma Red comes a devastatingly beautiful novel that challenges prevailing historical narratives of Sacajewea”--Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("Identifiers: LCCN 2022038367 (print) | LCCN 2022038368 (ebook) | ISBN 9781571311450 (hardcover) | ISBN 9781571317742 (epub)")]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("Subjects: LCSH: Sacagawea--Fiction. | LCGFT: Biographical fiction. | Novels.")]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("Classification: LCC PS3605.A765 L68 2022 (print) | LCC PS3605.A765 (ebook) | DDC 813/.6--dc23/eng/20221004")]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022038367",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022038367")])]), _vm._v(" "), _c('p', {
    staticClass: "CRT0h"
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022038368",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2022038368")])]), _vm._v(" "), _c('p', {
    staticClass: "CRT00"
  }, [_vm._v("Milkweed Editions is committed to ecological stewardship. We strive to align our book production practices with this principle, and to reduce the impact of our operations in the environment. We are a member of the Green Press Initiative, a nonprofit coalition of publishers, manufacturers, and authors working to protect the world’s endangered forests and conserve natural resources. "), _c('i', [_vm._v("The Lost Journals of Sacajewea")]), _vm._v(" was printed on acid-free 100% postconsumer-waste paper by Friesens Corporation.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0